import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Router} from "@angular/router";
import {SubscriptionContainerService} from "../../../../../../../base/services/subscription-container.service";
import {BaseComponent} from "../../../../../../../base/components/base.component";
import {EventBusService} from "../../../../../../../base/services/eventbus/event-bus.service";
import {INotification} from "../../models/notification.model";

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent extends BaseComponent {

  @Input() notification: INotification | null = null

  @Output() notificationItemClick: EventEmitter<INotification> = new EventEmitter<INotification>()
  @Output() onMarkRead: EventEmitter<{ notificationId: number, read: boolean }> = new EventEmitter<{
    notificationId: number,
    read: boolean
  }>()

  constructor(eventBus: EventBusService,
              router: Router,
              subContainer: SubscriptionContainerService
  ) {
    super(eventBus, router, subContainer);
  }

  protected componentName(): string {
    return "NotificationComponent";
  }

  ngOnInit(): void {
  }

  itemClick(notification: INotification | null) {
    if (notification == null) return
    this.notificationItemClick.emit(notification)
  }

  onActionRead(notificationId: number, read: boolean) {
    this.onMarkRead.emit({notificationId, read})
  }
}
